/* USER */
export const SET_PROVIDER = "SET_PROVIDER";
export const SET_USER = "SET_USER";
export const SET_CHAIN_ID = "SET_CHAIN_ID";
export const STORE_USER_KYC = "STORE_USER_KYC";
export const SET_KYC_SIGNATURE = "SET_KYC_SIGNATURE";
